import { Chart } from 'primereact/chart'

import './StatisticsChart.scss'
import Legend from '../../chart-components/legend/Legend'

export default function CampusSummaryChart(props: any) {
  const { icon, number, label, color, legends, data } = props

  const chartData = {
    labels: [legends.firstLegend, legends.secondLegend, legends.thirdLegend, legends.fourthLegend],
    datasets: [
      data.firstValue.number !== 0 ||
      data.secondValue.number !== 0 ||
      data.thirdValue.number !== 0 ||
      data.fourthValue.number !== 0
        ? {
            data: [data.firstValue.number, data.secondValue.number, data.thirdValue.number, data.fourthValue.number],
            backgroundColor: [color.firstColor, color.secondColor, color.thirdColor, color.fourthColor],
            hoverBackgroundColor: [color.firstColor, color.secondColor, color.thirdColor, color.fourthColor],
          }
        : {
            data: [100],
            backgroundColor: ['#cecece'],
            hoverBackgroundColor: ['#cecece'],
          },
    ],
  }

  const options = {
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled:
          data.firstValue.number !== 0 ||
          data.secondValue.number !== 0 ||
          data.thirdValue.number !== 0 ||
          data.fourthValue.number !== 0
            ? true
            : false,
      },
    },
  }

  return (
    <div className="statistic-container">
      <div className="statistics-total-container">
        <div className="statistic-icon">{icon}</div>
        <div className="statistic-total">
          <div className="d-flex align-items-center">
            <span className="number-total">{number}</span>
          </div>
          <p className="label-text label-title">{label}</p>
        </div>
      </div>

      <div className="chart-container">
        <Chart type="doughnut" data={chartData} className="statistic-chart" options={options} />
        <div className="d-flex">
          <div className="chart-legends campus-chart">
            <Legend color={color.firstColor} value={data.firstValue} legend={legends.firstLegend} />
            <Legend color={color.secondColor} value={data.secondValue} legend={legends.secondLegend} />
          </div>

          <div className="chart-legends campus-chart">
            <Legend color={color.thirdColor} value={data.thirdValue} legend={legends.thirdLegend} />
            <Legend color={color.fourthColor} value={data.fourthValue} legend={legends.fourthLegend} />
          </div>
        </div>
      </div>
    </div>
  )
}
